import React from 'react';
import { Edit, usePermissions, useEditContext, SimpleForm } from 'react-admin';
import { ensureStockTicketIds } from '../../utils/eventFormUtils';

import NoDeleteToolbar from '../../components/form/NoDeleteToolbar';
import {
  StandardProductFormComponent,
  SeatedProductFormComponent,
} from '../../components/stocks/StocksFormComponents';

/**
 * Stock row edit — products for one session / stock.
 * Kayit sonrasi event edit'e doner (oturumlar orada).
 */
export const StockEdit = (props) => {
  const { permissions } = usePermissions();
  if (!permissions) return null;

  return (
    <Edit title="Edit Stock / Products" {...props} redirect={false}>
      <StockEditForm />
    </Edit>
  );
};

const StockEditForm = () => {
  const { record } = useEditContext();
  if (!record) return null;

  const useSeatedForm =
    record.type === 3 || Boolean(record.seatSelections) || Array.isArray(record.stock);

  const eventId = record.event;
  const eventEditPath = eventId ? `/events-v2/${encodeURIComponent(eventId)}` : '/events-v2';

  return (
    <SimpleForm
      toolbar={<NoDeleteToolbar />}
      transform={(data) => ({
        ...data,
        stock: ensureStockTicketIds(data.stock),
      })}
      redirect={eventEditPath}
    >
      {eventId && (
        <p style={{ marginTop: 0 }}>
          <a href={`/#${eventEditPath}`}>← Event edit</a>
        </p>
      )}
      {!useSeatedForm ? (
        <StandardProductFormComponent stock={record} />
      ) : (
        <SeatedProductFormComponent stock={record} />
      )}
    </SimpleForm>
  );
};
